import apiClient from "./client";

/**
 * API Keys management
 */
const apiKeysApi = {
  /**
   * List all API keys for the current tenant.
   * The secret is never returned — only the prefix.
   */
  getAll: () => apiClient.get("/api-keys"),

  /**
   * Create a new API key. The full key value is returned ONCE in the response.
   * @param {{ name: string, description?: string, expiresOn?: string }} data
   */
  create: (data) => apiClient.post("/api-keys", data),

  /**
   * Revoke (deactivate) an API key. The key remains in the database.
   * @param {string} id
   */
  revoke: (id) => apiClient.patch(`/api-keys/${id}/revoke`),

  /**
   * Permanently delete an API key.
   * @param {string} id
   */
  delete: (id) => apiClient.delete(`/api-keys/${id}`),
};

export { apiKeysApi };
export default apiKeysApi;
